import React from 'react';

import NumberFormat from 'react-number-format';

import { DECIMAL_FRACTIONS } from '../../constants';

class CurrencyFormatter extends React.Component {
    render() {
        const { customPrefix, customSuffix, fractionsNumber, useFlexibleFractions } = this.props;
        const number = Number(this.props.children);

        let fractionsToUse = fractionsNumber !== undefined ? fractionsNumber : DECIMAL_FRACTIONS.DEFAULT;
        if (useFlexibleFractions) {
            fractionsToUse = Number.isInteger(number) ? DECIMAL_FRACTIONS.NO_CENTS : fractionsToUse;
        }

        return (
            <NumberFormat
                className="number-format"
                value={number !== null && number !== undefined && number.toFixed(fractionsToUse)}
                thousandSeparator={true}
                prefix={customPrefix !== null && customPrefix !== undefined ? customPrefix : '$'}
                suffix={customSuffix}
                displayType={'text'} />
        )
    }
}

export default CurrencyFormatter;